import { connect } from 'react-redux';
import withPageTitle from '../../hoc/withPageTitle';
import withTableSubscription from '../../hoc/withTableSubscription';
import { feedColumns } from '../../service/tickercolumns';
import {
    updateInterest,
    newInterests,
    fetchInterests,
    changeInterestsFilters,
    loadingInterests,
} from '../../actions/interests';
import InterestsPage from '../../components/pages/InterestsPage';

const sources = [
    'feed.index.nibor.INDICES_FIXING',
    'feed.e24.quotes.INTERESTS_US_TREASURY',
    'feed.e24.quotes.INTERESTS_SYNTHETIC',
    'feed.e24.index.INTERESTS_EURIBOR',
];

function mapStateToProps({ interests }) {
    return {
        title: 'Renter',
        ...interests,
        sources,
        columns: feedColumns,
    };
}

const mapDispatchToProps = {
    update: updateInterest,
    create: newInterests,
    fetch: fetchInterests,
    changeFilters: changeInterestsFilters,
    loadingInterests,
};

export default connect(mapStateToProps, mapDispatchToProps)(
    withTableSubscription(
        withPageTitle(InterestsPage)
    )
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/pages/InterestsPage.js
 **/